import CreditCardIcon from "@mui/icons-material/CreditCard";
import { Box, Button, Divider, Paper, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useState } from "react";
import { useParams } from "react-router-dom";

import usePerfilPU from "../../../services/usePerfilPU";

import Modal from "./Modal";

const CreditTransactionsCard = () => {
  const { slug } = useParams();
  const { data: profile, isLoading } = usePerfilPU();

  const [modalOpen, setModalOpen] = useState(false);

  if (!slug) {
    return null;
  }

  const saldo = isLoading
    ? "..."
    : profile && profile.credit[slug]
      ? profile.credit[slug].total_credit
      : "-";
  const dataSaldo = isLoading
    ? "..."
    : profile && profile.credit[slug]
      ? dayjs(profile.credit[slug].last_update).format("DD/MM/YYYY")
      : "-";

  return (
    <>
      <Paper
        elevation={3}
        sx={{
          p: 3,
          borderRadius: 3,
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
        }}
      >
        <Typography
          variant="h6"
          color="secondary.main"
          sx={{ display: "flex", alignItems: "center", mb: 2 }}
        >
          <CreditCardIcon sx={{ mr: 1 }} /> Crédito Disponível
        </Typography>
        <Divider sx={{ my: 1 }} />
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle1" fontWeight={700} color="primary.main">
            Saldo atual: <span style={{ fontSize: 24 }}>R$ {saldo}</span>
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Últ. atualização: {dataSaldo}
          </Typography>
        </Box>
        <Box sx={{ mt: "auto" }}>
          <Button variant="contained" onClick={() => setModalOpen(true)}>
            Ver extrato
          </Button>
        </Box>
      </Paper>
      <Modal open={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
};

export default CreditTransactionsCard;
